export default function OPENWINDOW (){
  
  $(document).on('click','[data-plugin="openwindow"]', e => {
    e.preventDefault();
    const $this = $(e.currentTarget),
          data = $this.data(),
          size = 'width='+(data.width||600)+', height='+(data.height||500)+',';
    window.open($this[0].href,(data.title||'share this site'),size+"menubar=no, toolbar=no, scrollbars=yes");
  })

}